export default __webpack_public_path__ + "static/media/WU.34afd6a0.svg";